module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-28.8d924742.png";